import { FicheConseilState } from '@lib/models/generated/graphql';

type StateNode = {
  next: FicheConseilState | undefined;
  previous: FicheConseilState[];
};

type StateMachine = {
  [state in FicheConseilState]: StateNode;
};

const STATE_MACHINE: StateMachine = {
  [FicheConseilState.DraftCreated]: {
    next: FicheConseilState.DraftInvestisseurValidated,
    previous: [],
  },
  [FicheConseilState.DraftInvestisseurSelected]: {
    next: FicheConseilState.DraftInvestisseurValidated,
    previous: [],
  },
  [FicheConseilState.DraftInvestisseurValidated]: {
    next: FicheConseilState.DraftKycValidated,
    previous: [FicheConseilState.DraftInvestisseurSelected],
  },
  [FicheConseilState.DraftKycValidated]: {
    next: FicheConseilState.DraftRequirementsAndNeedsValidated,
    previous: [FicheConseilState.DraftInvestisseurSelected, FicheConseilState.DraftInvestisseurValidated],
  },
  [FicheConseilState.DraftRequirementsAndNeedsValidated]: {
    next: FicheConseilState.DraftInvestmentProjectValidated,
    previous: [
      FicheConseilState.DraftInvestisseurSelected,
      FicheConseilState.DraftInvestisseurValidated,
      FicheConseilState.DraftKycValidated,
    ],
  },
  [FicheConseilState.DraftInvestmentProjectValidated]: {
    next: FicheConseilState.ConseilDone,
    previous: [
      FicheConseilState.DraftInvestisseurSelected,
      FicheConseilState.DraftInvestisseurValidated,
      FicheConseilState.DraftKycValidated,
      FicheConseilState.DraftRequirementsAndNeedsValidated,
    ],
  },
  [FicheConseilState.ConseilDone]: {
    next: undefined,
    previous: [
      FicheConseilState.DraftInvestisseurSelected,
      FicheConseilState.DraftInvestisseurValidated,
      FicheConseilState.DraftKycValidated,
      FicheConseilState.DraftRequirementsAndNeedsValidated,
      FicheConseilState.DraftInvestmentProjectValidated,
    ],
  },
};

export class FicheStateMachine {
  stateMachine = STATE_MACHINE;

  public getNextState(state: FicheConseilState): FicheConseilState | undefined {
    return this.stateMachine[state].next;
  }
  public canGoToPreviousState(currentState: FicheConseilState, targetState: FicheConseilState): boolean {
    return this.stateMachine[currentState].previous.includes(targetState);
  }
  public isLastState(state: FicheConseilState): boolean {
    return this.stateMachine[state].next === undefined;
  }
}
